<template>
    <div class="home">
        <div class="carousel-container" style="margin-top:-20px" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
            <div class="carousel-wrapper">
                <div class="carousel-track" :style="{
                    transform: `translateX(-${currentIndex * 100}%)`,
                    transition: 'transform 0.6s ease-in-out'
                }">
                    <div v-for="(gamb, index) in images" :key="index" class="carousel-slide">
                        <div class="ratio-box" :style="{ backgroundColor: backgroundColor }">
                            <img :src="'https://server-web.konaweselatankab.go.id/uploads/' + gamb.file"
                                :ref="setImageRef" @load="onImageLoad" alt="Image" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="controls">
                <button @click="prev">‹</button>
                <button @click="next">›</button>
            </div>
        </div>
        <!-- slider-area-end -->


        <!-- about-area -->
        <section class="about__area-two about__bg">
            <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
                data-background="assets/img/bg/about_bg.jpg"></div>
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-lg-6 col-md-8 hide-on-mobile">
                        <div class="about__img-wrap-two">
                            <!-- :src="'https://server-web.konaweselatankab.go.id/uploads/' + list_sambutan.foto" -->
                             <!-- <p>{{list_sambutan.file}}</p> -->
                            <img :src="'https://server-web.konaweselatankab.go.id/uploads/' + list_sambutan.foto" alt="Apexa" />
                            <div class="shape">
                                <img src="assets/img/images/h2_about_img_shape.png" alt="Apexa"
                                    class="alltuchtopdown" />
                            </div>
                            <div class="experience__box-two">

                                <!-- <div class="experience__content">
                                        <h4 class="title">01</h4>
                                        <p>
                                            Transnaker <br />
                                            Kepala Dinas
                                        </p>
                                    </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="about__content-two">
                            <div class="section-title mb-20 tg-heading-subheading animation-style3">
                                <span class="sub-title">Tentang </span>
                                <!-- <pre>{{list_sambutan}}</pre> -->
                                <h2 class="title tg-element-title text-primary">Badan Keuangan dan Aset Daerah.</h2>
                            </div>
                            
                            <!-- <div v-for="(item, index) in list_tentang" :key="index">
                                <div v-html="item.uraian"></div>
                            </div> -->
                            <!-- <div v-for="(item, index) in list_tentang" :key="index"> -->
                                <div v-html="list_sambutan.isi"></div>
                            <!-- </div> -->

                            <!-- <div class="about__content-inner">
                                <div class="about__list-box">
                                    <ul class="list-wrap">
                                        <li @click="linkto('/sekretariat')"><i class="flaticon-arrow-button"></i>Sekretariat</li>
                                        <li @click="linkto('/bid_akutansi')"><i class="flaticon-arrow-button"></i>Bidang Akutansi</li>
                                        <li @click="linkto('/bid_anggaran')"><i class="flaticon-arrow-button"></i>Bidang Anggaran</li>
                                        <li @click="linkto('/bid_aset')"><i class="flaticon-arrow-button"></i>Bidang Aset</li>
                                        <li @click="linkto('/bid_bud')"><i class="flaticon-arrow-button"></i>Bidang BUD</li>
                                    </ul>
                                </div>

                            </div> -->
                            <div class="about-bottom">
                                <!-- <div class="author-wrap">
                                    <div class="thumb">
                                         
                                        <img :src="'https://server-web.konaweselatankab.go.id/uploads/' + list_sambutan.foto" alt="Apexa" />
                                    </div>
                                    <div class="content">
                                        <img src="assets/img/images/sign.png" alt="Apexa" />
                                        <h4 class="title">{{list_sambutan.nama}} <span>, KEPALA BADAN</span></h4>
                                    </div>
                                </div> -->
                                <router-link class="btn btn-two" to="/tentang">Read More</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="about__shape-wrap-two">
                <img src="assets/img/images/h2_about_shape01.png" alt="Apexa"
                    data-parallax='{"x" : -80 , "y" : 80 , "rotateZ":80}' />
                <img src="assets/img/images/h2_about_shape02.png" alt="Apexa" data-parallax='{"y" : 100 }' />
                <img class="dark-opacity" src="assets/img/images/h2_about_shape03.png" alt="Apexa" data-aos="fade-left"
                    data-aos-delay="400" />
            </div>
        </section>
        <!-- about-area-end -->
        <!-- services-area -->
        <section class="services__area-two">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="section-title white-title mb-50 tg-heading-subheading animation-style3">
                            <span class="sub-title">Update informasi kamu di sini</span>
                            <h2 class="title tg-element-title">Ikuti perkembangan berita terbaru, hanya di website kami
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center gutter-24">
                    <div class="col-xl-4 col-lg-4 col-md-4" v-for="(data, index) in listBerita" :key="index">
                        <div class="blog__post-two shine-animate-item">
                            <div class="blog__post-thumb-two">
                                <a :href="'https://server-web.konaweselatankab.go.id/uploads/'+data.foto"
                                    class="shine-animate"><img
                                        :src="'https://server-web.konaweselatankab.go.id/uploads/'+data.foto"
                                        alt="Apexa" /></a>
                            </div>
                            <div class="blog__post-content-two">
                                <div class="blog-post-meta">
                                    <ul class="list-wrap">
                                        <li>
                                            <a href="blog.html" class="blog__post-tag-two">Lihat</a>
                                        </li>
                                        <li><i class="fas fa-calendar-alt"></i>{{UMUM.tglConvert(data.createAt).tgl}}
                                        </li>
                                    </ul>
                                </div>
                                <h2 class="title text-box"><a @click="routerKe('/Beritaisi/'+data.id)" href="javascript:void(0)" style="font-size: 12pt; text-align: justify !important;" >{{data.judul}} </a>
                                </h2>
                                <div class="blog-avatar">
                                    <div class="avatar-content">
                                        <p style="font-size: 12px;">✏️ <a href="blog-details.html">{{data.createBy}}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>





                </div>
            </div>
            <div class="services__shape-wrap">
                <img src="assets/img/images/h2_services_shape01.png" alt="Apexa" data-aos="fade-right"
                    data-aos-delay="400" />
                <img src="assets/img/images/h2_services_shape02.png" alt="Apexa" data-aos="fade-left"
                    data-aos-delay="400" />
            </div>
        </section>
        <!-- services-area-end -->
        <!-- choose-area -->
        <section class="choose__area-two">
            <div class="choose__bg" data-background="assets/img/bg/choose_bg.jpg"></div>
            <div class="container">
                <div class="row justify-content-end">
                    <div class="col-lg-8 col-md-10">
                        <div class="choose__content-two">
                            <div class="section-title mb-20 tg-heading-subheading animation-style3">
                                <!-- <span class="sub-title">Why Choose Our Services</span> -->
                                <h2 class="title tg-element-title">Link Terkait</h2>
                            </div>
                            <p style="text-align: justify;">Untuk memperluas pemahaman dan memberikan informasi tambahan
                                kepada pembaca, halaman ini menyediakan beberapa link terkait yang relevan dengan topik
                                yang dibahas. Link-link tersebut dapat mengarahkan Anda ke sumber referensi, artikel
                                pendukung, atau halaman lain yang memiliki keterkaitan informasi, sehingga pembaca dapat
                                menggali lebih dalam sesuai kebutuhan. Dengan adanya link terkait, diharapkan pengalaman
                                membaca menjadi lebih kaya dan menyeluruh.</p>
                            <div class="row">
                                <div class="col-lg-4 col-md-6 gy-4" v-for="data in listLink" :key="data.id">
                                    <div class="choose__box-two image-container">
                                        <a :href="data.url">
                                            <!-- <img :src="$store.state.UPLOADS + data.file" alt="gambar" class="responsive-img" /> -->
                                            <img :src="$store.state.UPLOADS+data.file"
                                                alt="gambar" class="responsive-img" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="operating__box">
                                <div class="icon">
                                    <i class="fas fa-globe"></i>
                                </div>
                                <div class="content">
                                    <p>
                                        Link Terkait - <br />

                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="choose__shape-wrap-two">
                <img src="assets/img/images/h2_choose_shape01.png" alt="Apexa"
                    data-parallax='{"x" : -80 , "y" : 80 , "rotateZ":80}' />
                <img class="dark-opacity" src="assets/img/images/h2_choose_shape02.png" alt="Apexa" data-aos="fade-left"
                    data-aos-delay="400" />
            </div>
        </section>
        <!-- choose-area-two -->
    </div>
</template>



<script>
import UMUM from '../library/umum.js';


export default {
    data() {
    return {
      UMUM:UMUM,
      msg: 'Welcome to Your Vue.js App',
      isVisible: false,
    //   mobileMenu:"",
      currentIndex: 0,
      images: [
        "https://server-web.konaweselatankab.go.id/uploads/1740462547777.png",
        "https://picsum.photos/id/1016/800/450",
        "https://picsum.photos/id/1018/800/450"
      ],
      intervalId: null,
      backgroundColor: "#FFFFFF",
      imageRef: null,
      listSlider:[],
      listBerita:[],
      listLink:[],
      list_tentang:[],
      list_sambutan:[],

      unit_kerja : "PYRiCmEdcQZdYxrhe",

      }
    },
  methods: {

    fetchSlider() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.BASE_URL + 'api/v1/publish_bpkad_slider/', {
            method: "GET",
            headers: {
            "content-type": "application/json",
            // authorization: "kikensbatara " + localStorage.token
            }, 
        })
        .then(res => res.json())
        .then(res_data => { 
            this.images = res_data  
            // console.log(this.images);
            
        });     
    },
    fetchBerita() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.BASE_URL + 'api/v1/web_publish_berita/homeOPD/', {
            method: "GET",
            headers: {
            "content-type": "application/json", 
            }, 
        })
        .then(res => res.json())
        .then(res_data => { 
            this.listBerita = res_data  
            // console.log(this.listBerita);
            
        });     
    },
    fetchTentang() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.BASE_URL + 'api/v1/publish_bpkad_tentang/view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_tentang = res_data  
            // console.log("this.list_tentang");
            // console.log(this.list_tentang);
            
        });     
    },


    fetchsambutan() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.BASE_URL + 'api/v1/publish_bpkad_sambutan/view', {
            method: "GET",
            headers: {
            "content-type": "application/json",
   
            }, 
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_sambutan = res_data[0]  
            console.log("this.fetchsambutan");
            console.log(this.list_sambutan);
            
        });     
    },    



    fetchLinkterkait() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.URL.link_terkait, {
            method: "POST",
            headers: {
            "content-type": "application/json",
            }, 
            body: JSON.stringify({
                // unit_kerja:"9emCdG8CwXXY2ws6f",
                unit_kerja:this.unit_kerja
            })
        })
        .then(res => res.json())
        .then(res_data => { 
            this.listLink = res_data  
            // console.log(this.listLink); 
            // console.log('fetchLinkterkait');
            
        });     
    },

    // =========================================
    // toggleMenu() {
    //   this.isVisible = !this.isVisible;
    // },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    startAutoplay() {
      this.intervalId = setInterval(() => {
        this.next();
      }, 6000); // Ganti gambar tiap 3 detik
    },
    stopAutoplay() {
      clearInterval(this.intervalId);
    },
        setImageRef(el) {
      this.imageRef = el;
    },
    onImageLoad() {
      if (!this.imageRef) return;

      try {
        const color = this.getDominantColor(this.imageRef);
        this.backgroundColor = color;
      } catch (e) {
        console.warn("Gagal ambil warna:", e);
      }
    },
    getDominantColor(imgEl) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = imgEl.naturalWidth;
      canvas.height = imgEl.naturalHeight;
      ctx.drawImage(imgEl, 0, 0);

      const { data } = ctx.getImageData(0, 0, 1, 1); // ambil piksel atas kiri
      const [r, g, b] = data;
      return `rgb(${r}, ${g}, ${b})`;
    },

    linkto(linknya){
        this.$router.push({path:linknya})
    },

    routerKe(data) { //Kalau ada parameternya
        this.$router.push(data)
    },


  },
  mounted() {
    this.fetchSlider()
    this.fetchBerita()
    this.fetchLinkterkait()
    this.fetchTentang()
    this.fetchsambutan()
    // this.mobileMenu = this.$refs.desktopMenu.innerHTML;

    this.startAutoplay();


    document.title = this.msg;

 

  },
  beforeUnmount() {
    this.stopAutoplay();

  }    

}
</script>


<style scoped> 
@media (max-width: 768px) {
  .hide-on-mobile {
    display: none !important;
  }
}




/* Container carousel */
.carousel-container {
  background-color: #ecf6fa !important;
  max-width: 100%;
  margin: auto;
  position: relative;
  overflow: hidden;
  border-radius: 0px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
}

.carousel-wrapper {
    background-color: #ecf6fa !important;
  width: 100%;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  max-width: 100%;
}

.ratio-box {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 */
  background-color: #ecf6fa;
  overflow: hidden;
  margin: 0px 0px;
}

.ratio-box img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Controls */
.controls {
  position: absolute;
  top: 50%;
  width: 100%;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
}

.controls button {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.controls button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.text-boxx {
  /* width: 320px; */
  /* height: 4em; */
  /* overflow: hidden; */
  /* display: -webkit-box; */
  /* -webkit-line-clamp: 3; Jumlah baris maksimal */
  /* -webkit-box-orient: vertical; */
    max-width: 100%;               /* Biar tidak melebihi parent */
  width: 100%;                   /* Full lebar kontainer */
  box-sizing: border-box;        /* Padding dihitung dalam width */
  padding: 1em;
  font-size: 1rem;               /* Responsive font */
  word-wrap: break-word;         /* Bungkus kata panjang */
  overflow-wrap: break-word;     /* Modern wrap */
  line-height: 1.5;
    display: -webkit-box;
   
   
  border-radius: 8px;



}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #f5f5f5;
  position: relative;
  border-radius: 10px;
  padding: 10px;
}

.responsive-img {
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.3s ease;
  object-fit: contain;
}

/* Efek hover */
.image-container:hover .responsive-img {
  transform: scale(1.05);
}  


.text-box {
  height: 60px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}
</style>


